import React from 'react';
import ReactDOM from 'react-dom/client';
import vars from '@/config/vars';
import consoleConfig from '@/services/console';
import App from './App';

// eslint-disable-next-line
console.log(`%cApp version: ${__VERSION__} (${vars.env})`, 'color:green');

consoleConfig.start(vars.console);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
